<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 28px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #eb401f;
}

input:focus + .slider {
  box-shadow: 0 0 1px #eb401f;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
<template>
  <div>
    <template v-if="viewPage === true && merchant !== null">
      <preLoader v-if="beneficiaryLoad === true"></preLoader>
      <div class="modal fade" id="merchantBeneficiaryPopup" tabindex="-1" role="dialog" aria-labelledby="merchantBeneficiaryPopupLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md" role="document">
          <div class="modal-content">
            <div class="modal-body p-5 text-left">
              <div class="popup-head mb-4 line-head">
                <h2 class="pb-3"> Payment Detail </h2>
              </div>
              <div class="people-management-inner-content">
                <div class="form-group">
                  <label class="label block-label">Payment to be transferred via <em class="required">*</em> </label>
                  <label class="radio-holder mb-0">
                    IBFT
                    <input v-model="beneficiary_form.account_type" type="radio" @click="paymentMethod = 'IBFT'" value="IBFT" class="payment-transfer" name="payment-transfer">
                    <span class="checkmark"></span>
                  </label>
                  <label class="radio-holder ml-0 mb-0">
                    Easy Paisa Wallet
                    <input type="radio" v-model="beneficiary_form.account_type" @click="paymentMethod = 'EASY_PAISA_WALLET'" value="EASY_PAISA_WALLET" class="payment-transfer" name="payment-transfer" checked="">
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="payment-via simsim" v-if="paymentMethod == 'EASY_PAISA_WALLET'">
                  <div class="form-group">
                    <label class="label block-label"> Wallet Number  <em class="required">*</em> </label>
                    <input type="text" placeholder="03XXXXXXXXX"  class="form-control" name="wallet_number" v-model="beneficiary_form.wallet_number" :class="{ 'is-invalid': beneficiary_form.errors.has('wallet_number') }" autocomplete="off"/>
                    <has-error :form="beneficiary_form" field="wallet_number"></has-error>
                  </div>
                  <a href="#" class="account fetch-info" title="" @click="getBeneficiaryDetail()"> Fetch Info </a>
                  <div class="form-group detail-fetched" v-if="showWalletDetail">
                    <div class="fetched-inner">
                      <div class="fetched-image">
                        <img src="/images/table-dummy-image.jpg" alt="" />
                      </div>
                      <div class="fetched-detail">
                        <h3> {{ customerNumber }}  </h3>
                        <p> {{mobileNumber}}  </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="payment-via bank"  v-show="paymentMethod == 'IBFT'">
                  <div class="form-group">
                    <label class="label block-label"> Bank Name <em class="required">*</em> </label>
                    <select v-model="beneficiary_form.bank_name" name="bank_name" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': beneficiary_form.errors.has('bank_name') }" v-if="banks != null">
                      <option value="" selected>Select Bank</option>
                      <option v-for="bank in banks" v-bind:value="{bank_code : bank.bankBin, bank_name : bank.bankName}" v-bind:key="bank.bankBin">
                        {{ bank.bankName }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label class="label block-label"> Account Number  <em class="required">*</em> </label>
                    <input type="text" placeholder="Account No." autocomplete="off" v-model="beneficiary_form.account_number" class="form-control" name="account_number" value="" :class="{ 'is-invalid': beneficiary_form.errors.has('account_number') }"/>
                    <has-error :form="beneficiary_form" field="account_number"></has-error>
                  </div>
                  <h3 class="mb-3" v-if="showIBFTDetail"> Fetched Acount Details </h3>
                  <a href="#" class="account get-info" title="" @click="getBeneficiaryDetail()"> Fetch Info </a>
                  <div class="fethed-account-detail mb-3"  v-if="showIBFTDetail">
                    <div class="row">
                      <div class="col-5"> <strong class="title"> Bank Name </strong> </div>
                      <div class="col-7"> {{bankName}} </div>
                    </div>
                    <div class="row">
                      <div class="col-5"> <strong class="title"> Account Number </strong> </div>
                      <div class="col-7"> {{accountNumber}} </div>
                    </div>
                    <div class="row">
                      <div class="col-5"> <strong class="title"> Account Title </strong> </div>
                      <div class="col-7"> {{accountTitle}} </div>
                    </div>
                    <div class="row">
                      <div class="col-5"> <strong class="title"> Branch Code </strong> </div>
                      <div class="col-7"> {{branchCode}} </div>
                    </div>
                  </div>
                </div>
                <div class="btn-holder text-right">
                  <button class="btn btn-primary" @click="hidePopup()"> Cancel </button>
                  <button class="btn btn-primary" @click="addMerchantBeneficiary()" disable="disable"> Save </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="page-top mb-1 mb-3 clearfix">
        <div class="row">
          <div class="col-6">
        <h1 class="float-left"> Distributor Configuration </h1>
          </div>
          <div class="col-3">
            <h2 class="float-left"> Loan Balance : Rs.{{merchant.loan_amount}} </h2>
          </div>
          <div class="col-3">
            <button class="btn btn-primary float-right" @click="settleNow()"> Settle Now </button>
          </div>
          </div>
      </div>
      <div class="vendor-profile-box mb-3" v-show="merchant !== null">
        <div class="row mb-4">
          <div class="col">
            <div class="vendor-profile-head clearfix">
              <h3> {{merchant.name}} </h3>
            </div>
          </div>
          <div class="col">
            <div class="vendor-profile-heading clearfix">
              <div class="row">
              <div class="col">
              <h3> Auto Sweep Schedule </h3>
              </div>
              <div class="col">
                <div class="row">
                <h3 class="col-2">OFF</h3>
                <label class="switch col-2">
                  <input type="checkbox" :checked="cronSchedule.status == 'YES'? true : false" v-on:click="autoSweepToggle()">
                  <span class="slider round"></span>
                </label>
                  <h3 class="col-2">ON</h3>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <span class="label block-label"> Phone </span>
            <p> {{merchant.phone}} </p>
          </div>
          <div class="col" v-show="cronSchedule.status == 'YES'">
              <label class="label block-label"> Type <em class="required">*</em></label>
              <select v-model="form.period"  name="schedule" class="form-control selectpicker custom-select2">
                <option v-for="period in periods" v-bind:value="period" v-bind:key="period">
                <option v-if="period == cronSchedule.crone_type" value="" selected>{{cronSchedule.crone_type}}</option>
                  {{ period == cronSchedule.crone_type?'': period }}
                </option>
              </select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <span class="label block-label"> Email </span>
            <p> {{merchant.email}} </p>
          </div>
          <div class="col" v-show="cronSchedule.status == 'YES' && (cronSchedule.crone_type == 'MONTHLY' || cronSchedule.crone_type == 'DAILY' || form.period == 'MONTHLY' || form.period == 'DAILY') ">
          <label class="label block-label"> Time <em class="required">*</em></label>
          <select v-model="form.time"  name="schedule" data-live-search="true"  class="form-control selectpicker custom-select2">
            <option v-for="time in times" v-bind:value="time" v-bind:key="time">
            <option v-if="time == cronSchedule.crone_time" value="" selected>{{time+':00'}}</option>
              {{ time == cronSchedule.crone_time? '' : time+':00' }}
            </option>
          </select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <span class="label block-label"> Address </span>
            <p> {{merchant.address_1}} </p>
          </div>
          <div class="col" v-show="cronSchedule.status == 'YES' && (cronSchedule.crone_type == 'MONTHLY' || form.period == 'MONTHLY')">
            <label class="label block-label"> Date <em class="required">*</em></label>
            <input v-model="form.date" type="number" :placeholder="cronSchedule.crone_date" name="name" maximum="31" minimum="1" class="form-control">
            <label class="label"> *Dates from 29 to 31 are discouraged.</label>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <span class="label block-label"> Available Loan Balance </span>
            <p> Rs.  {{merchant.loan_amount}} </p>
          </div>
          <div class="col">
            <button @click="setFormDataForCall()" class="btn btn-primary float-right active">Update Schedule</button>
          </div>
        </div>
      </div>
      <div class="row mb-12">
        <div class="col">
        <h3 class="vendor-profile-heading mb-3 float-left"> Beneficiaries </h3>
        </div>
        <div class="col">
        <button class="btn btn-primary float-right" @click="loadBankList()"> Add Beneficairy </button>
        </div>
      </div>

      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="complete-profile" role="tabpanel" aria-labelledby="complete-profile-tab">
          <table id="paymentDetail" class="table table-responsive-xl" style="width:100%">
            <thead>
            <tr>
              <th>No.</th>
              <th>Account Type</th>
              <th>Account Title</th>
              <th>Bank</th>
              <th>Account Number</th>
              <th>Default</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(beneficiary, index) in merchantBeneficiaries" :key="index">
              <td> {{index + 1}} </td>
              <td>{{beneficiary.account_type}}</td>
              <td>{{beneficiary.account_title}}</td>
              <td>{{beneficiary.bank_name}}</td>
              <td>{{beneficiary.account_number}}</td>
              <td v-if="beneficiary.is_default == 'YES'">{{beneficiary.is_default}}</td>
              <td v-if="beneficiary.is_default == 'NO'"><a href="javascript:void(0);" @click="makeDefault(beneficiary.id);">Mark Default</a></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <template v-else-if="viewPage === null && merchant === null">
      <preLoader></preLoader>
    </template>
    <template v-else-if="viewPage === false">
      <notAllowed></notAllowed>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      periods: ['15min','30min','45min','HOURLY','DAILY','MONTHLY'],
      times: ['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23'],
      form: new Form({
        period: '',
        company_id: this.$route.params.id,
        time : '',
        date : '',
      }),
      viewPage : null,
      beneficiaryLoad : false,
      merchant : null,
      defaultBeneficiaryAccNo : '',
      merchantBeneficiaries : null,
      cronSchedule : null,
      banks : null,
      paymentMethod : 'IBFT',
      showWalletDetail : false,
      showIBFTDetail : false,
      customerName : '',
      mobileNumber : '',
      bankName :false,
      accountNumber :false,
      beneficiary_form: new Form({
        account_type : 'IBFT',
        bank_name : '',
        wallet_number : '',
        account_number : '',
        account_title : '',
        branch_code : '',
        is_default : 'NO',
        id: this.$route.params.id
      }),
      make_default : new Form({
        id : '',
        uid: this.$route.params.id
      }),
    };
  },
  mounted() {
    this.$Progress.start();
    this.can("merchant_auto_sweep")
        .then(result => {
          this.viewPage = result.merchant_auto_sweep;
          // this.viewPage =true;
        })
        .then(result => {
          if (this.viewPage === true) {
            this.getmerchantDetailData();
            this.$Progress.finish();
          }
        });
    this.getmerchantDetailData();
    this.$Progress.finish();
  },
  methods: {
    makeDefault(id){
      this.$Progress.start();
      this.make_default.id = id;
      this.make_default.post('/api/makeMerchantDefaultBeneficiary')
          .then(res => {
            if (res.status == 200) {
              this.getmerchantDetailData();
              this.showToastBox('success','Company account set to default successfully');
              this.$Progress.finish();
            } else {
              this.$Progress.fail();
            }
          })
          .catch(err => {
            this.$Progress.fail();
            this.showAlertBox('error','Error to load data');
          });
    },
    getmerchantDetailData : function () {
      axios.get('/api/merchantAutoSweepDetail/'+this.$route.params.id)
          .then(res => {
            if(res.status == 200){
              // this.viewPage = res.data.viewPage;
              this.merchant = res.data.merchant;
              this.merchantBeneficiaries = res.data.merchantBeneficiaries;
              this.cronSchedule = res.data.merchantAutoSweepSchedule;
              $('.selectpicker').selectpicker('refresh');
              this.$Progress.finish();
            }else{
              this.$Progress.fail();
              this.showAlertBox('error','Error to load fee  voucher detail');
            }
          })
          .then(res =>{
            var merchantPaymentsTable = $('#paymentDetail').DataTable({
              "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
              deferRender: true,
            });
          })
          .catch(err => {
            console.log(err);
            this.$Progress.fail();
            this.showAlertBox('error','Error to load fee  vouhcer detail');
          });
    },
    loadBankList(){
      this.beneficiaryLoad = true;
      axios.get('/api/getMerchantAutoSweepIBFTBankList')
          .then(res => {
            if(res.status == 200){
              if(res.data.bankList != null){
                this.banks = res.data.bankList;
              }
              this.beneficiaryLoad = false;
              $("#merchantBeneficiaryPopup").modal("show");
            }else{
              this.showAlertBox('error','Error to load data');
            }
          })
          .then(res=>{
            $(this.$el).find('.selectpicker').selectpicker('refresh');
          })
          .catch(err => {
            console.log(err);
            $(this.$el).find('.selectpicker').selectpicker('refresh');
            this.showAlertBox('error','Error to load data');
          });
    },
    hidePopup(){
      $('#merchantBeneficiaryPopup').modal('hide');
      this.showWalletDetail = this.showIBFTDetail = false;
    },
    addMerchantBeneficiary() {
      this.$Progress.start();
      this.beneficiary_form.post('/api/addMerchantAutoSweepBeneficiary/'+this.form.company_id)
          .then(res => {
            console.log(res);
            if(res.status == 200){
              if(res.data.status == 200){
                this.$Progress.finish();
                this.showToastBox('success','Company beneficiary added successfully');
                $("#merchantBeneficiaryPopup").modal("hide");
                this.beneficiaryLoad = true;
                this.$router.go(this.$router.currentRoute);
                this.beneficiaryLoad = false;
              }else if(res.data.status == 409){
                this.$Progress.fail();
                this.showAlertBox('error','Beneficiary details already added against this company.');
              }else{
                this.$Progress.fail();
                this.showAlertBox('error','Some problem in your form data inside');
              }
            }else{
              this.$Progress.fail();
              this.showAlertBox('error','Some problem in your form data outside');
            }
          })
          .catch(err => {
            this.$Progress.fail();
            console.log(err);
            this.showAlertBox('error','Some problem in your form data call failed');
          });
    },
    getBeneficiaryDetail(){
      var walletNumber = this.beneficiary_form.wallet_number;
      var account_type = this.beneficiary_form.account_type;
      var bank_name = this.beneficiary_form.bank_name.bank_code;
      var account_number = this.beneficiary_form.account_number;
      var user_id = this.beneficiary_form.id;
      this.$Progress.start();
      axios.post('/api/validateMerchantAutoSweepBeneficiary', {
        walletNumber: walletNumber,
        account_type: account_type,
        bankCode: bank_name,
        toAccountNumber: account_number,
        user_id: user_id,
      })
          .then(res => {
            if(res.data.code == 200){
              if(account_type == 'EASY_PAISA_WALLET'){
                this.customerNumber = res.data.data.accountTitle;
                this.mobileNumber = this.wallet_number;
                this.beneficiary_form.account_title = res.data.data.accountTitle;
                this.showWalletDetail = true;
              }else{
                this.bankName = this.beneficiary_form.bank_name.bank_name;
                this.accountNumber = this.beneficiary_form.account_number;
                this.beneficiary_form.account_title = this.accountTitle = res.data.data.accountTitle;
                this.beneficiary_form.branch_code = this.branchCode = this.beneficiary_form.bank_name.bank_code;
                this.showIBFTDetail = true;
              }
              this.$Progress.finish();
            }else if(res.data.status == 409){
              this.showAlertBox('error','Beneficiary already exist');
            }else{
              this.$Progress.fail();
              this.showAlertBox('error',res.data.msg);
            }
          })
          .catch(err => {
            console.log(err);
            this.$Progress.fail();
            this.showAlertBox('error','Error to load data');
          });
    },
    setFormDataForCall(){
      if(this.form.period == '' && this.form.time == '' && this.form.date == ''){
        this.showToastBox('error', 'No Schedule Data was Altered');
      }else{
        if (this.form.period == '') {
          if (this.cronSchedule.crone_type) {
            this.form.period = this.cronSchedule.crone_type;
          } else {
            console.log('No Schedule Period Set');
          }
        }
        if (this.form.time == '') {
          if (this.cronSchedule.crone_time) {
            this.form.time = this.cronSchedule.crone_time;
          } else {
            console.log('No Schedule Time Set');
          }
        }
        if (this.form.date == '') {
          if (this.cronSchedule.crone_date) {
            this.form.date = this.cronSchedule.crone_date;
          } else {
            console.log('No Schedule Date Set');
          }
        }
        // alert('hello');
        this.updateCronSchedule();
      }
    },
    updateCronSchedule() {
      this.$Progress.start();
        this.form.post('/api/updateCronSchedule')
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                this.$Progress.finish();
                this.showToastBox('success', 'Schedule Updated Successfully');
                this.beneficiaryLoad = true;
                this.getmerchantDetailData();
                this.beneficiaryLoad = false;
              } else {
                this.$Progress.fail();
                this.showAlertBox('error', 'Some problem in your input.');
              }
            })
            .catch(err => {
              this.$Progress.fail();
              console.log(err);
              this.showAlertBox('error', 'Some problem in your form data call failed');
            });
      },
    autoSweepToggle(){
      let that = this;
      this.$Progress.start();
if (this.cronSchedule.status == 'YES') {
  Swal.fire({
    title: 'Are you sure?',
    text: 'Scheduled Auto Sweep will be swithched OFF!',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Switch Off'
  }).then((result) => {
    if (result.value) {
      axios.get("/api/autoSweepToggle")
          .then(res => {
            if (res.status == 200) {
              this.$router.go(this.$router.currentRoute);
            } else {
              this.$Progress.fail();
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
              })
            }
          })
          .catch(err => {
            console.log(err);
            this.$Progress.fail();
            this.showAlertBox('error', 'request could not be processed');
          });

    }else{this.$router.go(this.$router.currentRoute);}

  })
}
      if (this.cronSchedule.status == 'NO') {
        Swal.fire({
          title: 'Are you sure?',
          text: 'Scheduled Auto Sweep will be swithched ON!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Switch ON'
        }).then((result) => {
          if (result.value) {
            axios.get("/api/autoSweepToggle")
                .then(res => {
                  if (res.status == 200) {
                    this.$router.go(this.$router.currentRoute);
                  } else {
                    this.$Progress.fail();
                    Swal.fire({
                      icon: 'error',
                      title: 'Oops...',
                      text: 'Something went wrong!',
                    })
                  }
                })
                .catch(err => {
                  console.log(err);
                  this.$Progress.fail();
                  this.showAlertBox('error', 'request could not be processed');
                });

          }else{
            this.$router.go(this.$router.currentRoute);
          }
        })
      }
    },
    settleNow(){
      let that = this;
      this.$Progress.start();
if (this.merchantBeneficiaries == '') {
  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: 'No Company Beneficiary Found!',
  })
  this.$Progress.finish();
}else{
  let modifiedArr = this.merchantBeneficiaries.map(function (e) {
    if (e.is_default == 'YES') {
      that.defaultBeneficiaryAccNo = e.account_number;
    }
  });
  if (!this.merchant.loan_amount > 0) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'No Company Balance to Settle!',
    })
    this.$Progress.finish();
  } else {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Rs. ' + this.merchant.loan_amount + ' will be transferred to your acc# ' + that.defaultBeneficiaryAccNo,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Transfer Now'
    }).then((result) => {
      if (result.value) {
        axios.get("/api/settleMerchantAccountNow")
            .then(res => {
              if (res.status == 200) {
                if (res.data.code == 200) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Company account will be settled shortly!',
                  })
                  this.$Progress.finish();
                  this.$router.go(this.$router.currentRoute);
                }
                if (res.data.code == 403) {
                  Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'No Company Balance to Settle!',
                  })
                  this.$Progress.finish();
                } else {
                  Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Company account will be settled shortly!',
                  })
                  this.$router.go(this.$router.currentRoute);
                  this.$Progress.finish();
                  // this.$Progress.fail();
                  // Swal.fire({
                  //   icon: 'error',
                  //   title: 'Oops...',
                  //   text: 'Could Not Process Settlement!',
                  // })
                }
              } else {
                this.$Progress.fail();
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: 'Something went wrong!',
                })
              }
            })
            .catch(err => {
              console.log(err);
              this.$Progress.fail();
              this.showAlertBox('error', 'couldnt find requested data');
            });

      }
    })
  }
}
    },
  },
  created() {
    //
  }
}
</script>
